<script>
import {
  defineComponent, inject, h, ref,
} from 'vue';
import isEmpty from 'lodash/isEmpty';

import TableViewerLine from './TableViewerLine.vue';
import {
  TableViewerOpenedTabsState,
  isArrayOfObjects,
  isObject,
} from '../common/table-viewer';

const TableViewerComponent = defineComponent({
  functional: true,
  props: {
    data: {
      required: true,
      validator: () => true,
    },
    path: {
      // example: key.key2.key3
      type: String,
      required: false,
      default: '',
    },
    depth: {
      default: 0,
      required: false,
      type: Number,
    },
    isArrayElement: {
      type: Boolean,
      required: false,
      default: false,
    },
    isArrayObject: {
      type: Boolean,
      required: false,
      default: false,
    },
    name: {
      type: String,
      required: false,
      default: '',
    },
  },

  render(hack) {
    const props = hack.$props;
    const { data, depth } = props;
    const openedTabsState = inject(TableViewerOpenedTabsState);

    const showAllByDefault = ref(true);

    const arrowClick = (event, path) => {
      event.preventDefault();
      event.stopPropagation();

      if (openedTabsState.set.has(path)) {
        openedTabsState.set.delete(path);
      } else {
        openedTabsState.set.add(path);
      }

      openedTabsState.counter++;
    };

    // eslint-disable-next-line
    openedTabsState.counter; // reactive trigger !do not delete!

    const res = [];

    const getIsOpened = (path) => {
      if (!path) {
        return true;
      }

      const openedTabsStateHasPath = openedTabsState.set.has(path);

      const opened = showAllByDefault.value ? !openedTabsStateHasPath : openedTabsStateHasPath;
      return opened;
    };

    const getDeepValue = (value) => {
      if (isObject(value)) {
        return Object.keys(value).join(', ');
      }
      if (Array.isArray(value)) {
        return value.length ? getDeepValue(value[0]) : '';
      }
      return value;
    };

    if (isArrayOfObjects(data)) {
      const controlLineValue = getDeepValue(data);

      const isShowed = getIsOpened(props.path);

      const childrenPaths = data.map((value, index) => (props.path ? `${props.path}.${index}` : index),
      );

      res.push(
        h(TableViewerLine, {
          depth,
          path: props.path,
          name: props.name,
          value: isShowed ? '' : controlLineValue,
          opened: data.length === 0 ? null : isShowed,
          isValueButton: true,

          onArrowClick: (event) => {
            arrowClick(event, props.path);
          },
        }),
      );

      if (isShowed) {
        data.forEach((value, index) => {
          const path = childrenPaths[index];

          res.push(
            h(TableViewerComponent, {
              path,
              data: value,
              depth,
              isArrayObject: true,
            }),
          );
        });
      }
    } else if (Array.isArray(data)) {
      const isShowed = getIsOpened(props.path);
      const isEmptyArray = data.length === 0;

      const path = isEmptyArray ? props.path : `${props.path}.0`;
      const value = isEmptyArray ? '' : data[0];

      res.push(
        h(TableViewerLine, {
          depth,
          path,
          name: `${props.name} (${data.length})`,
          value: value,
          opened: data.length <= 1 ? null : isShowed,
          onArrowClick: (event) => {
            arrowClick(event, props.path);
          },
        }),
      );

      if (isShowed) {
        data.slice(1).forEach((value, localIndex) => {
          const index = localIndex + 1;

          const path = props.path ? `${props.path}.${index}` : index;

          res.push(h(TableViewerComponent, { path, data: value, depth }));
        });
      }
    } else if (isObject(data)) {
      const controlLineValue = getDeepValue(data);

      const path = props.isArrayObject ? props.path.split('.').slice(0, -1).join('.') : props.path;

      const isShowed = getIsOpened(path);

      if (props.name) {
        res.push(
          h(TableViewerLine, {
            depth,
            path: props.path,
            name: props.name,
            value: isShowed ? '' : controlLineValue,
            opened: isEmpty(data) ? null : isShowed,
            isValueButton: true,

            onArrowClick: (event) => {
              arrowClick(event, props.path);
            },
          }),
        );
      }

      if (isShowed) {
        Object.keys(data).forEach((key) => {
          const path = props.path ? `${props.path}.${key}` : key;
          const value = data[key];

          res.push(
            h(TableViewerComponent, {
              name: key,
              path,
              data: value,
              depth: depth + 1,
            }),
          );
        });
      }
    } else {
      const value = data;

      res.push(
        h(TableViewerLine, {
          depth,
          path: props.path,
          name: props.name,
          value,

          onArrowClick: (event) => {
            arrowClick(event, props.path);
          },
        }),
      );
    }

    return res;
  },
});

export default TableViewerComponent;
</script>
